var exports = {
  "kL": "MessageUploadProgress.module__container___ei15QW",
  "zc": "MessageUploadProgress.module__iconContainer___ei15QW",
  "Qs": "MessageUploadProgress.module__content___ei15QW",
  "Md": "MessageUploadProgress.module__fileName___ei15QW",
  "Ov": "MessageUploadProgress.module__fileSize___ei15QW",
  "L$": "MessageUploadProgress.module__progressContainer___ei15QW",
  "Ik": "MessageUploadProgress.module__progressBarIndeterminate___ei15QW",
  "U6": "MessageUploadProgress.module__pulse___ei15QW",
  "hr": "MessageUploadProgress.module__progressBar___ei15QW",
  "E$": "MessageUploadProgress.module__progressBarNormal___ei15QW",
  "cs": "MessageUploadProgress.module__progressBarFailed___ei15QW",
  "x7": "MessageUploadProgress.module__cancelButton___ei15QW",
};

module.exports = exports;
